export default {
  name: "VerificationCode",
  props: {
    // 验证码长度，默认6位
    codeLength: {
      type: Number,
      default: 6
    },
    // 初始倒计时时间（秒）
    initialCountdown: {
      type: Number,
      default: 59
    }
  },
  data() {
    return {
      codeArray: new Array(this.codeLength).fill(""),
      currentFocus: 0,
      countdown: 0,
      countdownTimer: null,
      hasSent: false // 标记是否已经发送过验证码
    };
  },
  mounted() {
    // 自动聚焦到第一个输入框
    this.$nextTick(() => {
      this.focusInput(0);
      // 监听隐藏输入框的自动填充（部分系统会填充到hiddenInput）
      if (this.$refs.hiddenInput) {
        this.$refs.hiddenInput.addEventListener("change", this.handleHiddenInput);
      }
    });
  },
  beforeDestroy() {
    // 清除定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
    // 移除事件监听
    if (this.$refs.hiddenInput) {
      this.$refs.hiddenInput.removeEventListener("change", this.handleHiddenInput);
    }
  },
  methods: {
    // 处理隐藏输入框的自动填充（核心：接收系统短信验证码）
    handleHiddenInput(event) {
      let value = event ? event.target.value : this.$refs.hiddenInput.value;
      if (!value) return;

      // 只保留数字，过滤其他字符
      const code = value.replace(/\D/g, "");
      if (code.length !== this.codeLength) return;

      // 填充到验证码数组
      this.codeArray = code.split("");
      this.checkComplete();
      // 清空隐藏输入框
      this.$refs.hiddenInput.value = "";
    },
    // 隐藏输入框获取焦点时，自动切换到第一个验证码输入框
    handleHiddenFocus() {
      this.focusInput(0);
    },
    // 处理输入
    handleInput(index, event) {
      const value = event.target.value;

      // 只允许输入数字
      if (!/^\d*$/.test(value)) {
        this.codeArray[index] = "";
        return;
      }
      this.codeArray[index] = value;

      // 如果输入了内容且不是最后一个输入框，自动聚焦到下一个
      if (value && index < this.codeLength - 1) {
        this.focusInput(index + 1);
      }

      // 检查是否所有输入框都已填满
      this.checkComplete();
    },
    // 处理键盘事件
    handleKeydown(index, event) {
      // 退格键处理
      if (event.key === "Backspace") {
        if (!this.codeArray[index] && index > 0) {
          // 如果当前输入框为空，删除前一个输入框的内容
          this.focusInput(index - 1);
          this.codeArray[index - 1] = "";
        }
      }

      // 左右箭头键切换输入框
      if (event.key === "ArrowLeft" && index > 0) {
        this.focusInput(index - 1);
      } else if (event.key === "ArrowRight" && index < this.codeLength - 1) {
        this.focusInput(index + 1);
      }

      // 回车键提交
      if (event.key === "Enter") {
        this.handleSubmit();
      }
    },
    // 处理焦点
    handleFocus(index) {
      this.currentFocus = index;
      // 确保隐藏输入框失去焦点（避免系统填充冲突）
      if (this.$refs.hiddenInput) {
        this.$refs.hiddenInput.blur();
      }
    },
    // 处理粘贴
    handlePaste(event) {
      event.preventDefault();
      const pasteData = event.clipboardData.getData("text").replace(/\D/g, ""); // 只保留数字

      if (pasteData.length > 0) {
        for (let i = 0; i < Math.min(pasteData.length, this.codeLength); i++) {
          this.codeArray[i] = pasteData[i];
        }

        // 聚焦到下一个空白输入框或最后一个输入框
        const nextEmptyIndex = this.codeArray.findIndex(item => item === "");
        if (nextEmptyIndex !== -1) {
          this.focusInput(nextEmptyIndex);
        } else {
          this.focusInput(this.codeLength - 1);
        }
        this.checkComplete();
      }
    },
    // 聚焦到指定输入框
    focusInput(index) {
      this.$nextTick(() => {
        if (this.$refs.codeInputs && this.$refs.codeInputs[index]) {
          this.$refs.codeInputs[index].focus();
          this.currentFocus = index;
        }
      });
    },
    // 检查是否完成输入
    checkComplete() {
      const completeCode = this.codeArray.join("");
      if (completeCode.length === this.codeLength) {
        this.$emit("complete", completeCode);
      }
    },
    // 处理提交
    handleSubmit() {
      const completeCode = this.codeArray.join("");
      if (completeCode.length === this.codeLength) {
        this.$emit("complete", completeCode);
      }
    },
    // 处理重新发送
    handleResend() {
      if (this.countdown > 0) return;

      // 触发重新发送事件，由父组件在滑块校验成功后调用 startCountdown
      this.$emit("on-resend");
    },
    // 开始倒计时
    startCountdown() {
      this.hasSent = true; // 标记已发送过验证码
      this.countdown = this.initialCountdown;
      if (this.countdownTimer) clearInterval(this.countdownTimer);
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 1000);
    },
    // 重置倒计时
    resetCountdown() {
      if (this.countdownTimer) clearInterval(this.countdownTimer);
      this.countdownTimer = null;
      this.countdown = 0;
    }
  },
  watch: {
    // 监听codeArray变化
    codeArray: {
      handler(newVal) {
        // 当有内容输入时自动跳转到下一个输入框
        const filledIndex = newVal.findIndex((item, index) => item !== "" && newVal[index - 1] === "");
        if (filledIndex > 0) {
          this.focusInput(filledIndex - 1);
        }
      },
      deep: true
    }
  }
};